
    const data = {"name":"src/core/icons/play-box","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m-9 13V8l5 4\"/>","originalColors":[],"stopColors":[]}}

            export default data
            